<template>
    <div>
        <Yukleniyor :data="lo"></Yukleniyor>
        <el-alert
                title="Santral Kaydı Yok"
                type="success"
                :closable="false"
                v-if="!Liste">
        </el-alert>
        <el-table
                class="table-xs"
                style="width: 100%"
                width="100%"
                :data="Liste"
                v-if="Liste"
                row-key="id"
                :height="Height">
            <el-table-column
                    prop="Tarih"
                    label="Zaman"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="Telefon"
                    label="Telefon"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="Senaryo"
                    label="Senaryo"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="Bekleme"
                    label="Bekleme Süresi"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="Konusma"
                    label="Konuşma Süresi"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="Dahili"
                    label="Dahili"
            >
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    import Yukleniyor from "../../../../Doc/Yukleniyor";

    export default {
        components: {Yukleniyor},
        props: ["Kisi_id", "Telefon"],
        data() {
            return {
                Liste: null,
                Height: window.innerHeight - 215,
                lo: false
            }
        },
        methods: {
            SayfaYukle() {
                if (this.Kisi_id) {
                    this.lo = true;
                    this.$store.dispatch("Get", {path: 'yonetim/kisi/ekran/' + this.Telefon + '/santral'})
                        .then(response => {
                            if (response.Durum === 'OK') {
                                this.Liste = response.Liste;
                                this.lo = false;
                            } else {
                                this.$message.error(response.Mesaj);
                                this.hata = response.Hata;
                            }
                        });

                }
            },
        },
        created() {
            this.SayfaYukle()
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/kisi/Ekran/KisiSantral.vue